import React from 'react'
import { useTranslation } from 'react-i18next'

const PoiStatus = ({ poi }) => {
  const { t } = useTranslation()

  const getStatusLabel = (status) => {
    if (status) {
      return t(`POI_STATUS_${status}`)
    }
    return ''
  }

  const getStatusDescription = (status) => {
    if (status) {
      return t(`POI_STATUS_DESCRIPTION_${status}`)
    }
    return ''
  }

  const getStatusClassName = (status) => {
    switch (status) {
      case 'DRAFT':
        return 'status-draft'
      case 'READY':
        return 'status-ready'
      default:
        return 'status-other'
    }
  }

  return (
    <div className="block-wrapper">
      <p>
        {t('POI_STATUS_LABEL')}: <strong>{getStatusLabel(poi.status)}</strong>
      </p>
      <p>{getStatusDescription(poi.status)}</p>
    </div>
  )
}

export default PoiStatus
